import { ThemeOptions } from '@mui/material'

export const font = 'Lato'
export const mode: 'light' | 'dark' = 'light'

export const theme: ThemeOptions = {
  palette: {
    mode,

    primary: {
      main: '#000000', // Schwarz
    },
    secondary: {
      main: '#666666', // Dunkelgrau
    },
    info: {
      main: '#999999', // Mittelgrau
    },
    success: {
      main: '#68855C', // Entsatürtes Grün
    },
    warning: {
      main: '#997B5B', // Entsatürtes Orange
    },
    error: {
      main: '#8A6B6B', // Entsatürtes Rot
    },
    background: {
      default: '#FFFFFF', // Weiß
    },
    text: {
      primary: '#000000', // Schwarz für Text
    },
  },

  typography: {
    fontFamily: [`"${font}"`, 'Helvetica', 'Arial', 'sans-serif'].join(','),
  },
}
